module.exports = __webpack_public_path__ + "4cd41850a1d5aee7dc28943edd3ab3c3.png";